import React from "react";
import styled from "styled-components";

export default function ThemeToggle({ checked, onClick }) {
  return (
    <SwitchButton
      type="button"
      onClick={onClick}
      role="switch"
      aria-checked={checked}
      aria-label={
        checked
          ? "Theme is dark. Activate to switch to light mode."
          : "Theme is light. Activate to switch to dark mode."
      }
      title={checked ? "Switch to light mode" : "Switch to dark mode"}
      $checked={checked}
    >
      <SwitchThumb aria-hidden="true" $checked={checked}>
        {checked ? (
          <SwitchIcon viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M14.5 3.5a8.5 8.5 0 1 0 6 14.5A9.5 9.5 0 1 1 14.5 3.5z"
              fill="currentColor"
            />
          </SwitchIcon>
        ) : (
          <SwitchIcon viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="4" fill="currentColor" />
            <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="12" y1="1.5" x2="12" y2="4.5" />
              <line x1="12" y1="19.5" x2="12" y2="22.5" />
              <line x1="1.5" y1="12" x2="4.5" y2="12" />
              <line x1="19.5" y1="12" x2="22.5" y2="12" />
              <line x1="4.6" y1="4.6" x2="6.8" y2="6.8" />
              <line x1="17.2" y1="17.2" x2="19.4" y2="19.4" />
              <line x1="17.2" y1="6.8" x2="19.4" y2="4.6" />
              <line x1="4.6" y1="19.4" x2="6.8" y2="17.2" />
            </g>
          </SwitchIcon>
        )}
      </SwitchThumb>
    </SwitchButton>
  );
}

const SwitchButton = styled.button`
  --switch-width: 98px;
  --switch-height: 48px;
  --switch-padding: 4px;
  --switch-border: 1px;
  --switch-thumb-size: 40px;

  width: var(--switch-width);
  height: var(--switch-height);
  box-sizing: border-box;
  border: var(--switch-border) solid transparent;
  border-radius: 999px;
  padding: var(--switch-padding);
  background: ${({ $checked }) => ($checked ? "#11364d" : "#e9dca8")};
  position: relative;
  display: flex;
  align-items: center;
  transition:
    background-color 240ms ease,
    border-color 240ms ease;
  flex: 0 0 auto;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.accentDark};
    outline-offset: 2px;
  }
`;

const SwitchThumb = styled.span`
  width: var(--switch-thumb-size);
  height: var(--switch-thumb-size);
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: ${({ $checked }) => ($checked ? "#06263a" : "#5b4300")};
  background: ${({ $checked }) => ($checked ? "#38a8da" : "#efc238")};
  transform: ${({ $checked }) =>
    $checked
      ? "translateX(calc(var(--switch-width) - var(--switch-thumb-size) - (var(--switch-padding) * 2) - (var(--switch-border) * 2)))"
      : "translateX(0)"};
  transition:
    transform 260ms cubic-bezier(0.2, 0.8, 0.2, 1),
    background-color 240ms ease;
`;

const SwitchIcon = styled.svg`
  width: 22px;
  height: 22px;
  display: block;
`;
